<template>
  <div class="animated fadeIn">
    <h1>Överför fakturor</h1>

    <p>Överför fakturor till Fortnox.</p>
    <b-row>
      <b-col>
        <b-button @click="GetInvoices()">
          <span class="glyphicon glyphicon-upload" aria-hidden="true"></span>
          Hämta fakturor
        </b-button>
        &nbsp;
        <b-button @click="TransferInvoices()">
          <span class="glyphicon glyphicon-upload" aria-hidden="true"></span>
          Överför till Fortnox
        </b-button>
      </b-col>
      <b-col> </b-col>
    </b-row>
    <br />
    <b-row>
      <b-button size="sm" @click="MarkAll(true)">Markera alla</b-button>
      &nbsp;
      <b-button size="sm" @click="MarkAll(false)">Avmarkera alla</b-button>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b>Totalt antal: {{ invoices.length }}</b>
      </b-col>
      <b-col>
        <b>Antal markerade: {{ GetMarked().length }} </b>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card cols="5" v-if="invoices.length > 0">
          <b-row>
            <b-col cols="1"><b>Fakturanr</b></b-col>
            <b-col cols="3"><b>Kund</b></b-col>
            <b-col cols="1"><b>Datum</b></b-col>
            <b-col cols="1"><b>Belopp</b></b-col>
            <b-col cols="4"><b></b></b-col>
          </b-row>
          <b-row v-for="(i, idx) in invoices" :key="idx">
            <b-col cols="1"
              ><b-icon-check-circle-fill
                v-if="i.marked"
                @click="ToggleSelected(i)"
              />
              <b-icon-circle v-if="!i.marked" @click="ToggleSelected(i)" />
              {{ i.InvoiceNo }}</b-col
            >
            <b-col cols="3">{{ i.InternalId }}-{{ i.Name }}</b-col>
            <b-col cols="1">{{ i.Date }}</b-col>
            <b-col cols="1">{{ i.Amount }}</b-col>
            <b-col cols="4">{{ i.res }}</b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "invoicetransfer",
  data() {
    return {
      invoices: [],
      updateList: [],
      logRefresherMs: 0,
    };
  },
  methods: {
    GetInvoices() {
      //alert("Get customers");
      api.get("/api/apiinvoice/GetUntransferedInvoices").then((res) => {
        this.invoices = res.data;
      });
    },
    MarkAll(v) {
      this.invoices.map(function (x) {
        x.marked = v;
      });
      this.$forceUpdate();
    },
    GetMarked() {
      //return this.invoices;
      return this.invoices.filter(function (x) {
        return x.marked;
      });
    },
    ToggleSelected(r) {
      r.marked = !r.marked;
      this.$forceUpdate();
    },
    TransferInvoices() {
      this.updateList = this.GetMarked();
      if (this.updateList.length == 0) {
        alert("Finns inga markerade företag att överföra.");
        return;
      }
      this.transferOneInvoice();
    },
    transferOneInvoice() {
      console.log("transferOneInvoice:" + this.updateList.length);

      this.logRefresherMs = 400;

      if (this.updateList.length > 0) {
        var i = this.updateList[0];
        api
          .post("/api/apieconomy/transferinvoice?invoiceid=" + i.InvoiceId)
          .then((res) => {
            i.res = res.data;
            this.updateList.shift();

            setTimeout(this.transferOneInvoice(), 1000);
            this.$forceUpdate();
          });
      } else {
        console.log("updateList is empty");

        //$scope.AddToLog("Överföring klar.");
        //$scope.UpdateLog();
      }
    },
  },
};
</script>